export const HIGHLIGHTED_TEXT_BG_COLOR = 'rgba(242,245,108,0.8)';
export const HIGHLIGHTED_TEXT_FONT_WEIGHT = 700;
